export const SOFTLINE_API_MASTER_DATA = '/v1/stammdaten';
